import React from 'react';
const AlertModal = ({title, content, onClose, onConfirm, isCancel}) => {
  return (
    <div className="modal">
      <div className="modalTitle">{title && title}</div>
        <div className="modalContent">
            {content && content}
        </div>
        <div className="modalBtn">
            <img onClick={onConfirm} src={require('../images/confirmBtn.png')} alt="confirmBtn"/>
            {isCancel && <img onClick={onClose} src={require('../images/cancelBtn.png')} alt="cancelBtn"/>}
        </div>
    </div>
  );
}

export default AlertModal;
